/* global angular, analytics_data, utag */

var informaSearchApp = angular.module('informaSearchApp');

var InformaResultsController = function InformaResultsController($scope, $sanitize, $location, searchService, viewHeadlinesStateService, $timeout, $window, facetAvailabilityService) {

    var vm = this;

    vm.service = searchService;
    
    vm.docs = [];
    vm.searchType = '';
    vm.location = $location;
    vm.themeOmdia = angular.element(document.body).hasClass('theme-omdia');

    $scope.headlinesOnly = viewHeadlinesStateService;
    var count = 0;

    //Sri ram code IPP-7254
    $scope.updateSearchType = function () {
        var newSearchObj = vm.location.search(),
            searchStr = Object.keys(newSearchObj).map(function (key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(newSearchObj[key])
            }).join('&');

        if (searchStr.length === 0) {
            searchStr = "#?page=1&searchtype=product&sortBy=relevance&sortOrder=desc#searchTop";
        } else {
            if (searchStr.indexOf("searchtype=product") > 0)
                searchStr = '#?' + searchStr + '#searchTop';
            else
                searchStr = '#?' + searchStr + '&searchtype=product#searchTop';
        }

        vm.service.createFilter('searchtype', 'product');
        console.log(vm.service.getParams());
        //vm.service.addParamable(parm);
        // clean fix: need to update facets
        window.location.assign(window.location.origin + window.location.pathname + searchStr);
        window.location.reload();
    }

    $scope.removeSearchType = function () {
        delete vm.location.search()["searchtype"];
        var newSearchObj = vm.location.search(),
            searchStr = Object.keys(newSearchObj).map(function (key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(newSearchObj[key])
            }).join('&');

        if (searchStr.length === 0) {
            searchStr = "#?page=1&sortBy=relevance&sortOrder=desc#searchTop";
        } else {          
                searchStr = '#?' + searchStr + '#searchTop';
        }

        // clean fix: need to update facets
        window.location.assign(window.location.origin + window.location.pathname + searchStr);
        window.location.reload();
    }

    $scope.ReplaceBrowser = function (body) {
      
        const regexp = /<a[^>]*>([^<]+)<\/a>/g;
        const matches = body.matchAll(regexp);

        for (const match of matches) {
            console.log(match);
           
        }
        
    }

    $scope.utagAnalytics = function () {
        if (count > 0) {
             var eventDetails = {
                Number_of_Results: '"' + $(".js-searchTotalResults").text() + '"',
                search_Keyword: '"' + $(".js-searchKeyword").text() + '"'
            };
            var dataObj = $.extend(analytics_data, eventDetails);
            if (typeof utag !== 'undefined') {
                utag.link(dataObj);
            }
         }
        count = count + 1;
    };

    $scope.getFormattedDate = function (originalDate) {
        return new Date(originalDate.replace(/T.+/, ''));
    };

    $scope.$watch(function () {
        return searchService.getSearchType();
    }, function () {
        vm.searchType = searchService.getSearchType();
    });

    $scope.$watchCollection(function () {
        return searchService.getResults();
    }, function () {
        $scope.getpagePosition = (searchService._pager.current-1) * (searchService._pager.perPage);
        vm.docs = searchService.getResults();
        $scope.utagAnalytics();
    });

    $scope.filterResult = function (url) {
        window.location = url;
        window.location.reload();
    };

    $scope.fireBookmark = function (article, event, key) {
        $timeout(function () {
			vm.docs[key].isArticleBookmarked = vm.docs[key].isArticleBookmarked ? false : true;
		}, 500);
    };

    $scope.$on('refreshPopOuts', function (ngRepeatFinishedEvent) {

		// Enable all facet options when search results land
		// $('.facets__section input').attr('disabled', null);
		facetAvailabilityService.enableFacets();

        if (window.indexPopOuts)
        window.indexPopOuts();
        if (window.indexBookmarks)
        window.indexBookmarks();
        if (window.autoBookmark)
        window.autoBookmark();
        if (window.findTooltips)
        window.findTooltips();
        if (window.renderRevealer)
        window.renderRevealer();
    });

    this.forceRefresh = function () {
        $window.location.reload(false);
    };

    vm.triggerHeadingClick = function($event) {
      var $header,
          headerData,
          headerUrl;
      
      if (!vm.themeOmdia || $event.target.tagName === "A") return;

      // get header element
      $header = $($event.currentTarget).find('.search-result__heading');
      headerUrl = $header.attr('ng-href');

      // if url not present on header dont track event either
      if (!headerUrl) return;

      // get and set analytics data from header
      headerData = $header.data('info');
      if(typeof utag !== 'undefined' && headerData) {
        utag.link($.extend(analytics_data, headerData));
      }

      // execute header clickthrough
      window.location = headerUrl;
    }

};

informaSearchApp.directive('onFinishRender', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last === true) {
                $timeout(function () {
                    scope.$emit('refreshPopOuts');
                });
            }
        }
    };
});

informaSearchApp.controller("InformaResultsController", ['$scope', '$sanitize', '$location', 'searchService', 'viewHeadlinesStateService', '$timeout', '$window', 'facetAvailabilityService', InformaResultsController]);
